if (!customElements.get('product-attribute-options')) {
  class ProductAttributeOptions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const link = event.target.closest('[data-product-option-link]');
      if (!link || !this.contains(link)) return;

      event.preventDefault();
      if (link.getAttribute('aria-current') === 'page' || this.isLoading) return;
      this.loadProduct(link);
    };

    async loadProduct(link) {
      const productUrl = new URL(link.href, window.location.origin);
      if (productUrl.origin !== window.location.origin) {
        window.location.assign(link.href);
        return;
      }

      this.isLoading = true;
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(productUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

        const responseHtml = await response.text();
        const incomingDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
        const currentContent = document.querySelector('#content > .container');
        const incomingContent = incomingDocument.querySelector('#content > .container');
        if (!currentContent || !incomingContent) throw new Error('Product content was not found');

        const replacementNodes = [...incomingContent.childNodes].map((node) => document.importNode(node, true));
        currentContent.replaceChildren(...replacementNodes);

        currentContent.querySelectorAll('.shopify-section[id]').forEach((section) => {
          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: section.id.replace(/^shopify-section-/, ''), section }
          }));
        });

        window.history.replaceState({}, '', `${productUrl.pathname}${productUrl.search}${productUrl.hash}`);
        const newOptions = document.querySelector('[data-product-option-link][aria-current="page"]');
        newOptions?.focus();
      } catch (error) {
        window.location.assign(link.href);
      } finally {
        this.isLoading = false;
        this.removeAttribute('aria-busy');
      }
    }

  }

  customElements.define('product-attribute-options', ProductAttributeOptions);
}
